<template>
  <div class="col-lg-12 pb-4">
    <div class="card">
      <div class="card-body">
        <div v-if="target">
          <h4 class="card-title mb-4">
            <div class="row">
              <div class="col-sm-4">
                {{ $t("overview.target-relation") }}
              </div>
              <div class="col-sm-8 text-right">
                <b-button
                  @click="refresh"
                  class="btn btn-sm p-0 px-1 mx-2"
                  variant="success"
                  v-if="
                    id_user === id_analys ||
                    id_user === manager ||
                    user_type === 'superadmin' ||
                    user_type === 'admin' ||
                    user_type === 'vvip'
                  "
                  ><i
                    :class="loading ? 'mdi-spin' : ''"
                    class="mdi mdi-18px mdi-refresh p-0"
                  ></i
                ></b-button>
              </div>
            </div>
          </h4>
          <div class="hori-timeline">
            <cytoscape
              v-if="dataWordCloud || dataFollow || dataMention"
              ref="cyRef"
              :afterCreated="afterCreated"
              :preConfig="preConfig"
              :config="config"
              v-on:mousedown="addNode"
              @click="link"
              v-on:cxttapstart="updateNode"
            >
            </cytoscape>
            <div
              v-else
              class="
                d-flex
                flex-column
                justify-content-center
                align-items-center
              "
              style="margin-top: 5%; margin-bottom: 5%"
            >
              <i class="bx bxs-network-chart bx-lg"></i>
              <span> {{ $t("all.dnf") }}</span>
            </div>
          </div>
        </div>
        <div v-if="loadingnew" class="mt-4 mx-auto p-5">
          <div class="text-center">
            <div
              class="spinner-border text-secondary"
              role="status"
              v-if="loadingnew"
            >
              <span class="sr-only"
                ><p>{{ $t("website.website-info") }}</p></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import appConfig from "@/app.config";
import TargetService from "@/helpers/target-profile.service";
import PreferenceService from "@/helpers/preference.service.js";
import TwintService from "@/helpers/twint.service";
import cola from "cytoscape-cola";
import noOverlap from "cytoscape-no-overlap";
import cytoscape from "cytoscape";

export default {
  props: [
    "nametarget",
    "imgtarget",
    "idtarget",
    "twitter",
    "id_analys",
    "manager",
    "id_user",
    "user_type",
    "in_report",
  ],
  // page: {
  //   title: "Timeline",
  //   meta: [{ name: "description", content: appConfig.description }]
  // },
  components: { Carousel, Slide },

  data() {
    var baseUrl = window.location.origin;
    return {
      baseUrl: baseUrl + "/project-overview/",
      loadingnew: false,
      dataRelation: false,
      dataWordCloud: false,
      dataFollow: false,
      dataMention: false,
      elastic: "",
      target: [],
      title: "Ontology",
      config: {
        layout: {
          name: "cola",
          animate: true,
          refresh: 5,
          maxSimulationTime: 10000,
          fit: true,
          randomize: true,
          avoidOverlap: true,
        },
        style: [
          {
            selector: "node[id='" + this.idtarget + "']",
            style: {
              width: "70px",
              height: "70px",
              content: "data(label)",
              "text-transform": "uppercase",
              "background-color": "#556ee6",
              color: "#555555",
              "font-size": "16px",
              "font-weight": "bold",
              "text-valign": "center",
              "text-halign": "center",
              "text-outline-color": "#556ee6",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "node[id='2rp']",
            style: {
              width: "50px",
              height: "50px",
              content: "data(label)",
              "text-transform": "uppercase",
              color: "#555555",
              "font-size": "14px",
              "font-weight": "bold",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#34c38f",
              "text-outline-color": "#34c38f",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "node[id='3wc']",
            style: {
              width: "50px",
              height: "50px",
              content: "data(label)",
              "text-transform": "uppercase",
              color: "#555555",
              "font-size": "14px",
              "font-weight": "bold",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#50a5f1",
              "text-outline-color": "#50a5f1",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "node[parent_node='word']",
            style: {
              width: "30px",
              height: "30px",
              content: "data(label)",
              "text-transform": "lowercase",
              color: "#555555",
              "font-size": "12px",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#2d577d",
              "text-outline-color": "#2d577d",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "node[id='4flwng']",
            style: {
              width: "50px",
              height: "50px",
              content: "data(label)",
              "text-transform": "uppercase",
              color: "#555555",
              "font-size": "14px",
              "font-weight": "bold",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#f46a6a",
              "text-outline-color": "#f46a6a",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "node[parent_node='following']",
            style: {
              width: "30px",
              height: "30px",
              content: "data(label)",
              "text-transform": "lowercase",
              color: "#555555",
              "font-size": "12px",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#943737",
              "text-outline-color": "#943737",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "node[id='5flwr']",
            style: {
              width: "50px",
              height: "50px",
              content: "data(label)",
              "text-transform": "uppercase",
              color: "#555555",
              "font-size": "14px",
              "font-weight": "bold",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#f1b44c",
              "text-outline-color": "#f1b44c",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "node[parent_node='follower']",
            style: {
              width: "30px",
              height: "30px",
              content: "data(label)",
              "text-transform": "lowercase",
              color: "#555555",
              "font-size": "12px",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#916d30",
              "text-outline-color": "#916d30",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "node[id='6mention']",
            style: {
              width: "50px",
              height: "50px",
              content: "data(label)",
              "text-transform": "uppercase",
              color: "#555555",
              "font-size": "14px",
              "font-weight": "bold",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#F6812B",
              "text-outline-color": "#F76300",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "node[parent_node='topmention']",
            style: {
              width: "30px",
              height: "30px",
              content: "data(label)",
              "text-transform": "lowercase",
              color: "#555555",
              "font-size": "12px",
              "text-valign": "center",
              "text-halign": "center",
              "background-color": "#F76300",
              "text-outline-color": "#F76300",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
            },
          },
          {
            selector: "edge",
            style: {
              width: 2,
              "line-color": "#eeeeee",
              "target-arrow-color": "#eeeeee",
            },
          },
          {
            selector: "edge[edge_type='relation']",
            style: {
              width: 2,
              "line-color": "#3b7862",
              "target-arrow-color": "#3b7862",
            },
          },
          {
            selector: "edge[source='3wc']",
            style: {
              width: 2,
              "line-color": "#50a5f1",
              "target-arrow-color": "#50a5f1",
            },
          },
          {
            selector: "edge[target='3wc']",
            style: {
              width: 2,
              "line-color": "#2d577d",
              "target-arrow-color": "#2d577d",
            },
          },
          {
            selector: "edge[source='4flwng']",
            style: {
              width: 2,
              "line-color": "#f46a6a",
              "target-arrow-color": "#f46a6a",
            },
          },
          {
            selector: "edge[target='4flwng']",
            style: {
              width: 2,
              "line-color": "#943737",
              "target-arrow-color": "#943737",
            },
          },
          {
            selector: "edge[source='5flwr']",
            style: {
              width: 2,
              "line-color": "#f1b44c",
              "target-arrow-color": "#f1b44c",
            },
          },
          {
            selector: "edge[target='5flwr']",
            style: {
              width: 2,
              "line-color": "#916d30",
              "target-arrow-color": "#916d30",
            },
          },
          {
            selector: "edge[source='6mention']",
            style: {
              width: 2,
              "line-color": "#943737",
              "target-arrow-color": "#F76300",
            },
          },
          {
            selector: "edge[target='6mention']",
            style: {
              width: 2,
              "line-color": "#943737",
              "target-arrow-color": "#F76300",
            },
          },
        ],
        elements: {
          nodes: [
            {
              data: {
                id: this.idtarget,
                label: this.nametarget,
              },
            },
            {
              data: {
                id: "3wc",
                label: "Word Cloud",
              },
            },
            {
              data: {
                id: "4flwng",
                label: "Following",
              },
            },
            {
              data: {
                id: "5flwr",
                label: "Follower",
              },
            },
            {
              data: {
                id: "6mention",
                label: "Top Mention",
              },
            },
          ],
          edges: [
            {
              data: {
                source: "3wc",
                target: this.idtarget,
              },
            },
            {
              data: {
                source: "4flwng",
                target: this.idtarget,
              },
            },
            {
              data: {
                source: "5flwr",
                target: this.idtarget,
              },
            },
            {
              data: {
                source: "6mention",
                target: this.idtarget,
              },
            },
          ],
        },
      },
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Timeline",
          active: true,
        },
      ],
      loading: false,
    };
  },
  methods: {
    // async getTargetDetail(){
    //   this.loadingnew = true,
    //   await TargetService.getDetailTarget(this.idtarget)
    //   .then(response => {
    //     this.loadingnew = false;
    //     this.target = response.data.data;
    //     // var json = JSON.parse('['+this.target.relation_profile+']');
    //     // json.forEach((val) => {
    //     //   const data_nodes = {"data":{"id": val.id, "label":val.name, "parent_node": "relation", "id_target": val.id}};
    //     //   this.config.elements.nodes.push(data_nodes);
    //     //   const data_edges = {"data":{"source":val.id, "target": '2rp'}};
    //     //   this.config.elements.edges.push(data_edges);
    //     // });
    //   })
    //   .catch(err => {
    //     this.loadingnew = false;
    //     console.log(err);
    //   });
    //   this.dataRelation = true;
    // },
    getPreferences() {
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
          this.getWordCloud();
          this.getTopFollow();
          this.getTopMention();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getWordCloud() {
      if (this.twitter && this.twitter.account) {
        await TwintService.getWordCloudElastic(
          this.elastic,
          this.twitter.account
        )
          .then((response) => {
            var word_cloud = response.data._source.wordcloud;
            word_cloud.forEach((val, index) => {
              const data_wc_nodes = {
                data: {
                  id: "wc-" + index,
                  label: val.word,
                  parent_node: "word",
                },
              };
              this.config.elements.nodes.push(data_wc_nodes);
              const data_wc_edges = {
                data: { source: "wc-" + index, target: "3wc" },
              };
              this.config.elements.edges.push(data_wc_edges);
            });
          })
          .catch((err) => {
            console.log(err);
          });
        this.dataWordCloud = true;
      }
    },
    async getTopFollow() {
      if (this.twitter && this.twitter.account) {
        await TwintService.getFollowElastic(this.elastic, this.twitter.account)
          .then((response) => {
            var followers = response.data._source.followers;
            var following = response.data._source.following;

            followers.forEach((val, index) => {
              const data_flwr_nodes = {
                data: {
                  id: "flwr-" + index,
                  label: val.username,
                  parent_node: "follower",
                },
              };
              this.config.elements.nodes.push(data_flwr_nodes);
              const data_flwr_edges = {
                data: { source: "flwr-" + index, target: "5flwr" },
              };
              this.config.elements.edges.push(data_flwr_edges);
            });

            following.forEach((val, index) => {
              const data_flwng_nodes = {
                data: {
                  id: "flwng-" + index,
                  label: val.username,
                  parent_node: "following",
                },
              };
              this.config.elements.nodes.push(data_flwng_nodes);
              const data_flwng_edges = {
                data: { source: "flwng-" + index, target: "4flwng" },
              };
              this.config.elements.edges.push(data_flwng_edges);
            });
          })
          .catch((err) => {
            console.log(err);
          });
        this.dataFollow = true;
      }
    },
    async getTopMention() {
      if (this.twitter && this.twitter.account) {
        await TwintService.getMentionsElastic(
          this.elastic,
          this.twitter.account
        )
          .then((response) => {
            var topmention = response.data._source.topmention;
            topmention.forEach((val, index) => {
              const data_top_nodes = {
                data: {
                  id: "top-" + index,
                  label: val.user_mention,
                  parent_node: "topmention",
                },
                username: val.username,
              };
              this.config.elements.nodes.push(data_top_nodes);
              const data_top_edges = {
                data: { source: "top-" + index, target: "6mention" },
              };
              this.config.elements.edges.push(data_top_edges);
            });
          })
          .catch((err) => {
            console.log(err);
          });
        this.dataMention = true;
      }
    },

    addNode(event) {
      // var node = event.target;
      // var type = node.data('parent_node');
      // console.log(type);
    },

    link(event) {
      var node = event.target;
      var type = node.data("parent_node");
      var key = node.data("label");
      var id_target = node.data("id_target");

      if (type == "topmention") {
        location.href = "https://twitter.com/" + key;
      } else if (type == "following") {
        location.href = "https://twitter.com/" + key;
      } else if (type == "follower") {
        location.href = "https://twitter.com/" + key;
      } else if (type == "word") {
        location.href =
          "https://twitter.com/search?q=" + key + "&src=typed_query";
      } else if (type == "relation") {
        location.href = this.baseUrl + id_target;
      }
    },
    deleteNode(id) {
      // console.log("node clicked", id);
    },
    updateNode(event) {
      console.log("right click node", event);
    },
    preConfig(cytoscape) {
      cytoscape.use(cola);
    },
    async afterCreated(cy = null) {
      if (cy !== null) {
        this.cy = cy;
      } else {
        cy = this.cy;
      }
      await cy;
      cy.load;
      cy.userZoomingEnabled(false);
      cy.layout(this.config.layout).run();
    },
    refresh() {
      this.loading = true;
      this.afterCreated();
      setTimeout(() => {
        this.loading = false;
      }, 2000);
    },
  },

  filters: {
    upper(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
    lower(value) {
      if (!value) return "";
      value = value.toString();
      return value.toLowerCase();
    },
  },
  beforeMount() {
    // this.getTargetDetail();
    this.getPreferences();
  },
};
</script>